import { render, staticRenderFns } from "./PluginPopup.vue?vue&type=template&id=7dbc0820&scoped=true&"
import script from "./PluginPopup.vue?vue&type=script&lang=js&"
export * from "./PluginPopup.vue?vue&type=script&lang=js&"
import style0 from "./PluginPopup.vue?vue&type=style&index=0&id=7dbc0820&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbc0820",
  null
  
)

export default component.exports